import AuthButtonContainer from './AuthButtonContainer';
import { IStoreState } from '../../../modules';
import QuestionsChallengeRequest from '../challenge-request/QuestionsChallengeRequest';
import { connect } from 'react-redux';
import { faComments } from '@fortawesome/free-solid-svg-icons';

class QuestionsAuthButton extends AuthButtonContainer<Props, {}> {
  static icon = faComments
  static authname = "Challenge Questions"
  static description = "Answer a challenge question"
  static authLevel = 750

  static challengeRequestComponent = QuestionsChallengeRequest

  get enrolled() {
    return this.props.authmethods.challengeQuestions.enrolled
  }

  get required() {
    return this.props.challenge.requiredCredentials.challengeQuestions
  }
}

const mapStateToProps = ({ auth, authmethods, challenge, intl }: IStoreState) => ({
  authmethods,
  challenge,
})

interface Props extends ReturnType<typeof mapStateToProps> {
}

export default connect(mapStateToProps)(QuestionsAuthButton)